<style scoped>
#botsgrid {
  display: grid;
  grid-template-areas:
    'tv'
    'list';
  grid-gap: 15px;
  grid-template-columns: 1fr;
}

@media all and (min-width: 800px) {
  #editbot {
    display: none;
  }
}

@media all and (max-width: 800px) {
  #botsgrid {
    grid-template-areas:
      'tv'
      'edit'
      'list';
    grid-template-columns: 1fr;
  }
  #edit {
    display: none;
  }
}

#botlist {
  grid-area: list;
  min-height: 480px;
}
#tv {
  grid-area: tv;
}
#editbot {
  grid-area: edit;
}
</style>

<template>
  <div id="botsgrid">
    <div
      id="tv"
      style="display: flex;"
    >
      <BotTV style="flex: 100%;" />
      <EditBot
        v-show="$store.state.bots.editMode"
        id="edit"
        :bot="$store.state.bots.editBot"
        style="flex: 39%; margin-left: 10px;"
      />
    </div>
    <EditBot
      v-show="$store.state.bots.editMode"
      id="editbot"
      :bot="$store.state.bots.editBot"
    />
    <BotsList id="botlist" />
  </div>
</template>

<script>
import Decimal from 'decimal.js'
import BotTV from './BotTV'
import BotsList from './BotsList'
import EditBot from './EditBot'

export default {
  name: 'Bots',
  components: {
    BotsList,
    BotTV,
    EditBot
  },
  watch: {
    '$store.state.sys.tradeExchange' (newExch) {
      // console.log('Bots tradeExchange changed')
      if (this.$store.state.bots.exchSymbol[newExch.Id]) {
        this.$store.state.bots.symbol = this.$store.state.bots.exchSymbol[newExch.Id]
      }

      let newSymbol = 'BTC_USDT'
      if (
        this.$store.state.bots.exchSymbol &&
        this.$store.state.bots.exchSymbol[newExch.Id]
      ) {
        newSymbol = this.$store.state.bots.exchSymbol[newExch.Id]
      } else {
        switch (newExch.ExchId) {
          case 'BIN':
          case 'BIM':
          case 'HUO':
            newSymbol = 'BTC_USDT'
            break
          case 'EXM':
          case 'BIT':
          case 'FTX':
            newSymbol = 'BTC_USD'
            break
        }
      }
      const z = () => {
        if (this.$store.state.bots.symbol === newSymbol) {
          this.$store.state.bots.setSymbolNeeded = Date.now()
        }
        this.$store.state.bots.symbol = newSymbol

        // console.log('bots.symbol changed')
      }
      this.$store.dispatch('updateSymbols', { z })
      // this.$store.dispatch('updateSymbols', { z }).then(() => {
      //   console.log('updateSymbols dispatch done222')
      // })

      // if (this.$store.state.trade.symbol === newSymbol) {
      //   this.$store.dispatch('updateAssetBalance')
      // } else {
      //   this.$store.state.trade.symbol = newSymbol
      // }

      // this.cleanTV()
      // this.tvWidget.chart().setSymbol(this.chartSymbol, () => {
      //   // console.log('symbol loaded')
      //   // this.saveNeeded()
      // })
    }
  },
  created () {
    Decimal.set({ toExpNeg: -10 })
  }
}
</script>
